import { Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import Hexagon from '@public/images/cases/telehealth-software/svg/gray-hexagon.svg'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.newSpaces.xl5}px;
  min-height: 351px;
  position: relative;
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.lg}px;
      margin-top: ${({ theme }) => theme.newSpaces.xl2}px;
    `}
  `}
`

export const Content = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `}
  `}
`

export const Members = styled(Box)`
  flex-flow: column wrap;
  max-height: 250px;
  width: 440px;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl2}px;

    ${theme.below.desktop`
      flex-flow: row wrap;
      gap: 0 ${theme.newSpaces.lg}px;
    `}

    ${theme.below.laptopL`
      flex-flow: column wrap;
      gap: 0px;
    `}

    ${theme.below.laptop`
      align-items: center;
      margin: 0 auto ${theme.newSpaces.xs}px;
    `}

    ${theme.below.mobileXL`
      align-items: center;
      height: 225px;
      margin-bottom: -30px;
    `}

    ${theme.below.mobileM`
      margin-bottom: 0;
    `}
  `}
`

export const ImageWrapper = styled(Box)`
  height: 429px;
  max-width: 643px;
  position: relative;
  top: -45px;
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
       top: 0;
    `}

    ${theme.below.tablet`
      height: 450px;
    `} 

    ${theme.below.tabletS`
      height: 400px;
    `} 
    ${theme.below.mobileXL`
      height: 280px;
    `}

    ${theme.below.mobileL`
      height: 220px;
    `}
  `}
`

export const TeamImage = styled(ImageWithPlaceholder)`
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  object-fit: contain;
`

export const TeamHexagon = styled(Hexagon)`
  left: 18%;
  position: absolute;
  top: -5%;

  ${({ theme }) => css`
    ${theme.below.mobileXL`
      right: -5%;
      top: -30%;
    `}

    ${theme.below.mobileXL`
      display: none;
    `}
  `}
`

export const TeamTwoHexagon = styled(Hexagon)`
  left: 32%;
  position: absolute;
  top: 60%;

  ${({ theme }) => css`
    ${theme.below.laptopL`
      display: none;
    `}
  `}
`
